<template>
<div class='vx-col w-full mt-4'>
    <div class="cabecera">
        <vs-button @click="f_agregar_juego();">Agregar</vs-button>
    </div>
    <vs-popup fullscreen :title="tituloModal" :active.sync="modalJuegosAddEdit">
        <div class="vx-row">
            <div class="vx-col w-1/2">
                <!-- <div v-if="tipo_accion==0 && tipoJuego>0">  {{datos_editar.codigo}}-->
                <div v-if="datos_editar.codigo == null && tipo_accion==0 && tipoJuego>0">
                    <vs-button icon="arrow_back" @click="f_volver()">Volver</vs-button>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <!-- ********************* CODIGO DEL JUEGO CREADO******************* {{ datos_editar }} -->
                <div v-if="datos_editar.codigo != '' && datos_editar.codigo != null">
                    <div class="flex justify-end">
                        <p class="mb-2">Código:</p> &nbsp; <h2 class=" "><b class="bg-primary text-white caja-codigo p-2"> {{ datos_editar.codigo }} </b></h2>
                    </div>
                </div>
            </div>
            <vs-divider v-if="(tipo_accion==0 && tipoJuego>0) || datos_editar.codigo != '' && datos_editar.codigo != null " />
        </div>
        <div class="seleccionar-tipo-juego" v-if="tipoJuego==0">
            <div class="tipoJuego">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div v-for="(card,index) in listaTipos" :key="index" class="bg-white shadow-md rounded-lg p-6 cursor-pointer" @click="f_select_tipo(card)">
                        <h2 class="text-xl font-bold mb-2 text-center">{{ card.nombre }}</h2>
                        <p class="text-gray-700 text-center">{{ card.descripcion }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- ##############------JUEGO EMPAREJAR------################ -->
        <section class="------JUEGO EMPAREJAR------">
            <!-- op_show_columnas {{ listaJuegos }} -->
            <!-- <br> tipoJuego {{ tipoJuego }} -->
            <div class="juego-columnas" v-if="op_show_emparejar  && tipoJuego > 0">
                <Admin_emparejar v-if="modalJuegosAddEdit" @get_listar_juegos="get_listar_juegos" :datos_tipo_juego_select="datos_tipo_juego_select" :datos_editar="datos_editar" :tipo_accion="tipo_accion" />
            </div>
        </section>
        <!-- ##############------FIN JUEGO EMPAREJAR------################ -->
        <!-- ##############------JUEGO COLUMNAS------################ -->
        <section class="------JUEGO COLUMNAS------">
            <!-- op_show_columnas {{ op_show_columnas }} -->
            <!-- <br> tipoJuego {{ tipoJuego }} -->
            <div class="juego-columnas" v-if="op_show_columnas  && tipoJuego > 0">
                <Admin_columnas v-if="modalJuegosAddEdit" @get_listar_juegos="get_listar_juegos" :datos_tipo_juego_select="datos_tipo_juego_select" :datos_editar="datos_editar" :tipo_accion="tipo_accion" />
            </div>
        </section>
        <!-- ##############------FIN JUEGO COLUMNAS------################ -->
        <!-- ##############------JUEGO MEMORIA------################ -->
        <section class="------JUEGO MEMORIA------">
            <div class="juego-memoria" v-if="op_show_memoria  && tipoJuego > 0">
                <Memoria_admin v-if="modalJuegosAddEdit" @get_listar_juegos="get_listar_juegos" :datos_tipo_juego_select="datos_tipo_juego_select" :datos_editar="datos_editar" :tipo_accion="tipo_accion" />
            </div>

        </section>
        <!-- ##############------FIN JUEGO MEMORIA------################ -->
    </vs-popup>
    <div class="lista">
        <vs-table :data="listaJuegos" class="mt-4">
            <template slot="thead">
                <vs-th width="50%">Nombre</vs-th>
                <vs-th width="30%">Detalles</vs-th>
                <vs-th width="20%">Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="tr.nombre">
                        <p># {{ tr.id }}</p>
                        <p>{{tr.nombre | title}}</p>
                        <p>{{tr.descripcion}} </p>
                        <p>{{tr.created_at | formatoFecha}} </p>
                        <vs-chip v-if="tr.estado == 0" color="danger">Inactivo</vs-chip>
                        <vs-chip v-if="tr.estado == 1" color='success'>Activo</vs-chip>
                    </vs-td>
                    <vs-td :data="tr.codigo">
                        Código:<b class="text-primary"> {{tr.codigo}} </b>
                        <p>Área: <b>{{tr.nombrearea}}</b></p>
                        <p>Aubnivel: <b>{{tr.nombresubnivel}}</b></p>
                        <p class="text-warning">Juego de: <b>{{tr.tipojuego}}</b></p>
                        <p>Editor: <b>{{tr.usuarionombre}} {{tr.usuarioapellido}}</b></p>
                        <p>Puntaje: <b>{{tr.puntaje}}</b></p>
                        <!-- {{ tr }} -->
                        <p v-if="tr.id_grupo == 1">
                            <vs-chip color="#8d8f91">Administrador</vs-chip>
                        </p>
                    </vs-td>
                    <vs-td>
                        <vs-button @click="f_edit_juego(tr)" icon=edit color="warning"></vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </div>
</div>
</template>

<script>
import Admin_emparejar from './emparejar/admin_emparejar.vue';
import Admin_columnas from './columnas/admin_columnas.vue';
import Memoria_admin from './memoria/memoria_admin.vue';
export default {
    components: {
        Admin_emparejar,
        Admin_columnas,
        Memoria_admin,
    },
    data() {
        return {
            listaJuegos: [],
            tipoJuego: 0,
            listaTipos: [],
            tipoSelect: {},
            modalJuegosAddEdit: false,
            tituloModal: '',
            datos_tipo_juego_select: {},
            agregar_juego: false,
            codigo_creado: false,
            dato_cabecera: false,
            btn_cancelar: false,
            datos_juego_cabecera: [],
            tipo_accion: 0, //0 agregar, 1 editar
            datos_editar: {},
            op_show_emparejar: false,
            op_show_columnas: false,
            op_show_memoria: false,
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            me.f_listar_juegos();
            me.f_get_tipos();
        },
        f_get_tipos() {
            let me = this;
            // me.$vs.loading();
            me.$http.get(this.$server_url + 'tiposGames')
                .then(function (response) {
                    // console.log(response.data);
                    me.listaTipos = response.data;
                })
                .catch(function () {
                    me.f_notificaciones("No se obtuvo datos desde la DB", "danger");
                    // me.$vs.loading.close();
                })
        },
        f_listar_juegos() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'juegos')
                .then(function (response) {
                    me.listaJuegos = response.data;
                    me.$vs.loading.close();
                    // console.log('lista juegos', me.listaJuegos);
                })
                .catch(function (error) {
                    console.log(error);
                    me.$vs.loading.close();
                });
        },
        f_agregar_juego() {
            let me = this;
            localStorage.removeItem("codigo");
            me.tipoJuego = 0;
            me.tipo_accion = 0;
            me.tituloModal = 'Agregar juego';
            me.datos_tipo_juego_select = {}
            me.datos_editar = {}
            me.modalJuegosAddEdit = true;
            // me.op_show_emparejar = false;
            me.codigo_creado = false;
        },
        f_select_opciones(id_tipo_juego) {
            let me = this;
            // console.log('me.f_select_opciones', id_tipo_juego)
            me.op_show_emparejar = false;
            me.op_show_columnas = false;
            me.op_show_memoria = false;
            switch (id_tipo_juego) {
                case 1:
                    me.tipoJuego = 1; //id del tipo de juego
                    me.op_show_emparejar = true;
                    return;
                case 2:
                    me.tipoJuego = 2; //id del tipo de juego
                    me.op_show_columnas = true;
                    return;
                case 3:
                    me.tipoJuego = 3; //id del tipo de juego
                    me.op_show_memoria = true;
                    return;
                default:
                    me.tipoJuego = 0;
                    // me.tituloModal = 'Agregar juego'
                    break;
            }
        },
        f_select_tipo(item) {
            let me = this;
            me.agregar_juego = true;
            me.tipo_accion = 0; //agregar
            me.f_select_opciones(item.id);
            // console.log('select tipo', me.tipoJuego, 'op_show_emparejar', me.op_show_emparejar, 'op_show_columnas', me.op_show_columnas);
            me.tituloModal = 'Agregar juego'
            me.datos_tipo_juego_select = item;
            me.modalJuegosAddEdit = true;
        },
        f_edit_juego(item) {
            let me = this;
            localStorage.removeItem("codigo");
            me.datos_tipo_juego_select = {
                id: item.id_tipo,
                nombre: item.tipojuego
            };
            me.codigo_creado = true;
            me.datos_editar = item;
            me.tipo_accion = 1; //editar juego
            me.f_select_opciones(item.id_tipo);
            me.tituloModal = 'Editar juego'
            me.modalJuegosAddEdit = true;
        },
        f_volver() {
            let me = this;
            me.agregar_juego = false;
            me.tipoJuego = 0;
            me.datos_tipo_juego_select = {}
        },
        get_listar_juegos(e) {
            let me = this;
            me.datos_editar=e;
            // console.log('get_listar_juegos==>',e)
            me.f_listar_juegos();
        }

    }
};
</script>

<style scoped>
.card-juego {
    width: 30%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
}

.caja-codigo {
    border-radius: 15px;
    letter-spacing: 2px;

}
</style>
